import type { MaybeRef } from '@vueuse/core'

interface ContainerSizeProps {
  width: MaybeRef<number>
  height: MaybeRef<number>
  isSmall: MaybeRef<boolean>
  isMedium?: MaybeRef<boolean>
  isLarge?: MaybeRef<boolean>
}

const KeyContainerSize = Symbol('KeyContainerSize') as InjectionKey<ContainerSizeProps>

export function provideContainerSize(containerSize: ContainerSizeProps) {
  provide(KeyContainerSize, containerSize)
}

export function useContainerSize() {
  const containerSize = inject(KeyContainerSize, {
    width: 0,
    height: 0,
    isSmall: false,
  })

  return containerSize
}
